import * as React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { COLORS, BREAKPOINTS } from '../styles';
import { ChevronRight } from '../icons';
import { Product } from '../types';

type CardProps = {
  product: Product;
  url?: string;
};
const ProductLink = styled(Link)`
  display: flex;
  flex: 1;
  margin: 10px 8px;
  color: ${COLORS.black};
  text-decoration: none;

  ${BREAKPOINTS.MEDIUM} {
    width: 305px;
  }
`;

const ProductThing = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);

  &:hover {
    background: ${COLORS.primary_20};

    .product-chevron-right-path {
      fill: ${COLORS.primary_600};
    }
  }
  &:active {
    background: ${COLORS.primary_100};

    .product-chevron-right-path {
      fill: ${COLORS.primary_600};
    }
  }
`;

const ProductImage = styled.img`
  width: 95px;
  height: 75px;
  object-fit: fill;
  border-radius: 8px;
`;

const ProductName = styled.h2`
  font-size: 18px;
  line-height: 1.2;
  margin: 0;
  margin-top: 3px;
`;

const ProductType = styled.span`
  font-size: 16px;
  line-height: 1.2;
  margin: 0;
`;

const ProductInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 18px;
  flex: 1;
`;

const RightIconWrapper = styled.div`
  display: flex;
  justify-self: flex-start;
  align-items: center;
  padding-right: 12px;
`;

const MiniProductCard = ({ url, product }: CardProps) => {
  return (
    <ProductLink to={url ?? ''}>
      <ProductThing>
        {product.image && <ProductImage src={product.image} />}
        <ProductInnerWrapper>
          <ProductName>{product.name}</ProductName>
          <ProductType>{product.type}</ProductType>
        </ProductInnerWrapper>
        <RightIconWrapper>
          <ChevronRight color={COLORS.primary} className={'product-chevron-right'} size={'24px'} />
        </RightIconWrapper>
      </ProductThing>
    </ProductLink>
  );
};

export default MiniProductCard;
